<template>
  <div>
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <!-- Card -->
        <div class="card mt-5">
          <!-- Header -->
          <div class="card-header border-bottom-0 pb-0">
            <div class="row align-items-center">
              <div class="col">
                <!-- Title -->
                <h4 class="card-header-title mb-0">TNA Mitra</h4>
              </div>
            </div>
          </div>

          <div class="p-4">
            <!-- Period Selection -->
            <div class="row mb-4">
              <div class="col-lg-4">
                <label class="form-label">Period :</label>
                <v-select
                  v-model="selectedPeriod"
                  :options="periodOptions"
                  :reduce="option => option.value"
                  label="label"
                  placeholder="Silakan pilih"
                  :clearable="false"
                  :loading="periodsLoading"
                >
                </v-select>
              </div>
            </div>

            <!-- History and This Year Section -->
            <div class="row mb-4">
              <!-- History Section -->
              <div class="col-md-6">
                <h5 class="mb-3">History</h5>
                <div class="progress mb-2" style="height: 25px;">
                  <div 
                    class="progress-bar bg-primary" 
                    role="progressbar" 
                    :style="`width: ${summary.history.percentage}%;`" 
                    :aria-valuenow="summary.history.percentage" 
                    aria-valuemin="0" 
                    aria-valuemax="100"
                  >
                    {{ summary.history.percentage }}%
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-warning">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-target"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Plan</p>
                        <h3 class="mb-0">{{ summary.history.submitted }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-teal">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check-circle"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Approved</p>
                        <h3 class="mb-0">{{ summary.history.approved }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-success">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Completed</p>
                        <h3 class="mb-0">{{ summary.history.completed }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- This Year Section -->
              <div class="col-md-6">
                <h5 class="mb-3">This Year</h5>
                <div class="progress mb-2" style="height: 25px;">
                  <div 
                    class="progress-bar bg-success" 
                    role="progressbar" 
                    :style="`width: ${summary.this_year.percentage}%;`" 
                    :aria-valuenow="summary.this_year.percentage" 
                    aria-valuemin="0" 
                    aria-valuemax="100"
                  >
                    {{ summary.this_year.percentage }}%
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-warning">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-target"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Plan</p>
                        <h3 class="mb-0">{{ summary.this_year.submitted }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-teal">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check-circle"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Approved</p>
                        <h3 class="mb-0">{{ summary.this_year.approved }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-success">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Completed</p>
                        <h3 class="mb-0">{{ summary.this_year.completed }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- All Course Section -->
          <div class="card-body pt-2">
          <!-- Filter Bar -->
          <div class="row align-items-center mb-4">
            <div class="col-md-2">
              <h6 class="mb-0 font-weight-bold">Course List</h6>
            </div>
            <div class="col-md-10">
              <div class="d-flex justify-content-end align-items-center gap-2">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-info"
                  @click="downloadTemplate"
                  :disabled="isDownloading">
                  <span v-if="isDownloading">
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Downloading...
                  </span>
                  <span v-else>
                    <i class="fe fe-download me-1"></i>
                    Download Template
                  </span>
                </button>
                <button 
                  type="button"
                  class="btn btn-sm btn-success"
                  @click="showBulkUploadModal">
                  <i class="fe fe-upload me-1"></i>
                  Upload Excel
                </button>
                <div style="width: 250px;">
                  <input
                    type="text"
                    v-model="filters.search"
                    class="form-control form-control-sm"
                    placeholder="Search Training..." />
                </div>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger position-relative"
                  @click="showFilterModal">
                  <span class="fe fe-sliders"></span> Filter
                  <span 
                    v-if="activeFiltersCount > 0" 
                    class="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill"
                    style="font-size: 0.65rem; padding: 0.2rem 0.4rem;">
                    {{ activeFiltersCount }}
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- Active Filters Display -->
          <div v-if="activeFiltersCount > 0" class="mb-3">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <small class="text-muted">Active Filters:</small>
              
              <span v-if="filters.status" class="badge bg-light text-dark border">
                Status: {{ statusFilterLabel }}
                <button 
                  type="button" 
                  class="btn-close btn-close-sm ms-1" 
                  @click="clearSingleFilter('status')"
                  style="font-size: 0.6rem; padding: 0.1rem;"></button>
              </span>
              
              <span v-if="filters.approval_step" class="badge bg-light text-dark border">
                Approval: {{ approvalStepLabel }}
                <button 
                  type="button" 
                  class="btn-close btn-close-sm ms-1" 
                  @click="clearSingleFilter('approval_step')"
                  style="font-size: 0.6rem; padding: 0.1rem;"></button>
              </span>
              
              <span v-if="filters.course_type" class="badge bg-light text-dark border">
                Course Type: {{ courseTypeLabel }}
                <button 
                  type="button" 
                  class="btn-close btn-close-sm ms-1" 
                  @click="clearSingleFilter('course_type')"
                  style="font-size: 0.6rem; padding: 0.1rem;"></button>
              </span>
              
              <button 
                type="button" 
                class="btn btn-sm btn-link text-danger p-0 ms-2"
                @click="clearAllFilters">
                Clear All
              </button>
            </div>
          </div>

          <!-- Loading State -->
          <div v-if="isLoading" class="text-center py-5">
            <div class="spinner-border text-danger" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2 text-muted">Loading training data...</p>
          </div>

          <!-- Empty State -->
          <div v-else-if="paginatedCourses.length === 0" class="text-center py-5">
            <i class="fe fe-inbox" style="font-size: 3rem; color: #dee2e6;"></i>
            <p class="mt-3 text-muted">No training found</p>
          </div>

          <!-- Cards Grid -->
          <div v-else class="row">
            <div class="col-lg-3 col-md-6 col-sm-12 mb-4" v-for="course in paginatedCourses" :key="course.id">
              <div class="card h-100 shadow-sm border course-card" @click="viewCourseDetail(course)" style="cursor: pointer;">
                <!-- Card Image/Thumbnail -->
                  <div class="position-relative">
                    <img 
                      :src="`${imageBaseUrl}/attachments/${course.cover_image_path}`" 
                      :alt="course.title"
                      class="card-img-top"
                      style="height: 180px; object-fit: cover;"
                      @error="handleImageError">
                    
                    <!-- Status Badge -->
                    <div class="position-absolute" style="top: 8px; left: 8px;">
                      <span :class="getStatusBadgeClass(course.training_status)">
                        {{ course.training_status }}
                      </span>
                    </div>

                    <!-- TNA Status Badge -->
                    <div class="position-absolute" style="bottom: 8px; right: 8px;">
                      <span :class="course.tna_status === 'Open' ? 'badge bg-success' : 'badge bg-warning'">
                        {{ course.tna_status }}
                      </span>
                    </div>
                  </div>                
                <!-- Card Body -->
                <div class="card-body p-3">
                  <!-- Badges Row -->
                  <div class="mb-2 d-flex flex-wrap gap-1">
                    <span class="badge-icon bg-danger-soft text-danger">
                      <i :class="getTrainingTypeIcon(course.training_type)" style="font-size: 10px;"></i>
                    </span>
                    <span class="badge-custom bg-warning-soft text-warning">
                      {{ course?.role_competency || '-' }}
                    </span>
                    <span class="badge-custom bg-info-soft text-info">
                      {{ course?.role_competency_type || '-' }}
                    </span>
                  </div>
                  
                  <!-- Course Title -->
                  <h6 class="card-title font-weight-bold mb-2" style="font-size: 0.95rem; line-height: 1.3; min-height: 40px;">
                    {{ course.title }}
                  </h6>

                  <!-- Course Description -->
                  <p class="card-text text-muted course-description">
                    {{ course.description }}
                  </p>
                </div>
                
                <!-- Card Footer -->
                <div class="card-footer bg-white border-top px-3 py-2">
                  <div class="d-flex justify-content-between align-items-center">
                    <!-- Left: Duration & Participants -->
                    <div class="d-flex gap-3">
                      <div class="d-flex align-items-center">
                        <i class="fe fe-clock text-muted me-1" style="font-size: 0.85rem;"></i>
                        <small class="text-muted" style="font-size: 0.75rem;">{{ Number(course.hour || 0) }}h</small>
                      </div>
                      <div class="d-flex align-items-center">
                        <i class="fe fe-users text-muted me-1" style="font-size: 0.85rem;"></i>
                        <small class="text-muted" style="font-size: 0.75rem;">{{ course.tna_participant_count || 0 }}</small>
                      </div>
                    </div>
                    
                    <!-- Right: Detail Button -->
                    <button class="btn btn-sm btn-outline-danger">
                      <i class="fe fe-eye" style="font-size: 0.8rem;"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination Footer -->
          <div v-if="!isLoading && paginatedCourses.length > 0" class="mt-4 pt-3 border-top">
            <div class="row align-items-center">
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <span class="text-muted small me-2">Show</span>
                  <select 
                    v-model="perPage" 
                    class="form-select form-select-sm" 
                    style="width: 70px;"
                    @change="onPerPageChange">
                    <option v-for="option in perPageOptions" :key="option" :value="option">{{ option }}</option>
                  </select>
                  <span class="text-muted small ms-2">entries</span>
                </div>
              </div>
              <div class="col-md-4 text-center">
                <p class="text-muted small mb-0">
                  Showing {{ ((currentPage - 1) * perPage) + 1 }} to {{ Math.min(currentPage * perPage, totalItems) }} of {{ totalItems }} entries
                </p>
              </div>
              <div class="col-md-4">
                <nav aria-label="Course pagination">
                  <ul class="pagination pagination-sm justify-content-end mb-0">
                    <!-- Previous Button -->
                    <li class="page-item" :class="{ disabled: currentPage <= 1 }">
                      <button 
                        class="page-link" 
                        @click="changePage(currentPage - 1)"
                        :disabled="currentPage <= 1">
                        <i class="fe fe-chevron-left"></i>
                      </button>
                    </li>
                    
                    <!-- Page Numbers -->
                    <template v-for="(page, index) in visiblePages">
                      <!-- Show dots -->
                      <li 
                        v-if="page === '...'" 
                        :key="'dots-' + index"
                        class="page-item disabled">
                        <span class="page-link">...</span>
                      </li>
                      <!-- Show page number -->
                      <li 
                        v-else
                        :key="page"
                        class="page-item"
                        :class="{ active: page === currentPage }">
                        <button 
                          class="page-link" 
                          @click="changePage(page)">
                          {{ page }}
                        </button>
                      </li>
                    </template>
                    
                    <!-- Next Button -->
                    <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
                      <button 
                        class="page-link" 
                        @click="changePage(currentPage + 1)"
                        :disabled="currentPage >= totalPages">
                        <i class="fe fe-chevron-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modals -->
  <modal-tna-mitra-detail 
    :selectedCourse="selectedCourse"
  />
  
  <modal-course-filter
    :modal-id="filterModalId"
    :value="filters"
    :status-options="statusOptions"
    :approval-step-options="approvalStepOptions"
    :course-type-options="courseTypeOptions"
    @apply-filters="applyFilters"
    @reset-filters="resetFilters"
  />

  <modal-bulk-upload @upload-success="handleUploadSuccess" />
  </div>
</template>

<script>
import logic from './tna-mitra.logic.js';
import ModalTnaMitraDetail from './components/modal-tna-mitra-detail.vue';
import ModalCourseFilter from '@/components/mitra/ModalCourseFilter.vue';
import ModalBulkUpload from './components/modal-bulk-upload.vue';
import mitraCourseListFilter from '@/mixins/mitraCourseListFilter';

export default {
  ...logic,
  mixins: [mitraCourseListFilter],
  components: {
    ModalTnaMitraDetail,
    ModalCourseFilter,
    ModalBulkUpload
  }
};
</script>

<style scoped>
.me-2 {
  margin-right: 0.5rem;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 1rem;
}

/* Tab Navigation */
.nav-tabs .nav-link {
  color: #6c757d;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
}

.nav-tabs .nav-link.active {
  color: #000;
  background-color: transparent;
  border-bottom: 2px solid #dc2626;
}

.nav-tabs .nav-link:hover {
  border-bottom: 2px solid #dc2626;
}

/* Status Cards */
.status-card {
  border-radius: 12px;
  padding: 20px;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.status-icon {
  width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.status-card p {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
}

.status-card h3 {
  font-size: 32px;
  font-weight: bold;
  margin: 0;
}

.bg-teal {
  background-color: #5bc0be;
}

/* Progress Bar */
.progress {
  background-color: #e9ecef;
  border-radius: 0.5rem;
}

.progress-bar {
  font-weight: 600;
  font-size: 14px;
}

/* Course Card Styles */
.course-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.course-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

/* Badge Styles */
.badge-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 50%;
  font-size: 0.7rem;
}

.badge-custom {
  padding: 0.25rem 0.5rem;
  font-size: 0.65rem;
  font-weight: 600;
  border-radius: 0.25rem;
}

/* Soft Badge Colors */
.bg-danger-soft {
  background-color: #fce4e4;
}

.text-danger {
  color: #e63757 !important;
}

.bg-warning-soft {
  background-color: #fef5e4;
}

.text-warning {
  color: #f6c343 !important;
}

.bg-info-soft {
  background-color: #e4f4f7;
}

.text-info {
  color: #39afd1 !important;
}

/* Pagination */
.pagination .page-link {
  color: #2c7be5;
  border: 1px solid #dee2e6;
  padding: 0.375rem 0.75rem;
}

.pagination .page-item.active .page-link {
  background-color: #e63757;
  border-color: #e63757;
  color: white;
}

.pagination .page-item.disabled .page-link {
  cursor: default;
  background-color: transparent;
  border-color: transparent;
  color: #6c757d;
  pointer-events: none;
}

.pagination .page-link:hover:not(.disabled) {
  background-color: #f8f9fa;
}

.pagination .page-item.active .page-link:hover {
  background-color: #d32f4f;
  border-color: #d32f4f;
}

/* Course Description */
.course-description {
  font-size: 0.8rem;
  line-height: 1.4;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
